import { useState, useRef, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import gsap from "gsap";

import "./header.scss";
import { Link } from "react-router-dom";

const Header = () => {
  const [showsidebar, setShowSidebar] = useState(false);
  const { hash } = useLocation();
  // const isActive = (iHash) => hash === iHash;

  const handleShowSidebar = () => setShowSidebar(true);
  const handleClose = () => setShowSidebar(false);
  const handleShow1 = () => setShowSidebar(true);

  const handleClick = (e) => {
    setShowSidebar(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "/#home";
    }, 1000);
  };
  const handleClick1 = (e) => {
    setShowSidebar(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "/#aboutus";
    }, 1000);
  };
  const handleClick2 = (e) => {
    setShowSidebar(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "/#choose";
    }, 1000);
  };
  const handleClick3 = (e) => {
    setShowSidebar(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "/#ourwork";
    }, 1000);
  };
  const handleClick4 = (e) => {
    setShowSidebar(false);
    e.preventDefault();
    setTimeout(() => {
      window.location.href = "/#getintouch";
    }, 1000);
  };
  const [linePosition, setLinePosition] = useState(null); // State to store left position
  const [isHovered, setIsHovered] = useState(false); // State for hover

  const handleMouseEnter = (left) => {
    setLinePosition(left); // Update line position
    setIsHovered(true); // Show line
  };

  const handleMouseLeave = () => {
    setIsHovered(false); // Hide line
  };

  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400 && window.scrollY > lastScrollY) {
        setIsHidden(true); // Hide on scroll down
      } else {
        setIsHidden(false); // Show on scroll up
      }
      setLastScrollY(window.scrollY); // Update last scroll position
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]); // Depend on lastScrollY for reactivity

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const dropdown = dropdownRef.current;

    if (dropdown) {
      dropdown.addEventListener("show.bs.dropdown", () => setIsOpen(true));
      dropdown.addEventListener("hide.bs.dropdown", () => setIsOpen(false));
    }

    return () => {
      if (dropdown) {
        dropdown.removeEventListener("show.bs.dropdown", () => setIsOpen(true));
        dropdown.removeEventListener("hide.bs.dropdown", () =>
          setIsOpen(false)
        );
      }
    };
  }, []);

  const [isOpen1, setIsOpen1] = useState(false);
  const dropdownRef1 = useRef(null);

  useEffect(() => {
    const dropdown = dropdownRef1.current;

    if (dropdown) {
      dropdown.addEventListener("show.bs.dropdown", () => setIsOpen1(true));
      dropdown.addEventListener("hide.bs.dropdown", () => setIsOpen1(false));
    }

    return () => {
      if (dropdown) {
        dropdown.removeEventListener("show.bs.dropdown", () => setIsOpen1(true));
        dropdown.removeEventListener("hide.bs.dropdown", () =>
          setIsOpen1(false)
        );
      }
    };
  }, []);

  const [isOpen2, setIsOpen2] = useState(false);
  const dropdownRef2 = useRef(null);

  useEffect(() => {
    const dropdown = dropdownRef2.current;

    if (dropdown) {
      dropdown.addEventListener("show.bs.dropdown", () => setIsOpen2(true));
      dropdown.addEventListener("hide.bs.dropdown", () => setIsOpen2(false));
    }

    return () => {
      if (dropdown) {
        dropdown.removeEventListener("show.bs.dropdown", () => setIsOpen2(true));
        dropdown.removeEventListener("hide.bs.dropdown", () =>
          setIsOpen2(false)
        );
      }
    };
  }, []);
  const location = useLocation();
  const currentRoute = location.pathname;
  const isActive = location.pathname.startsWith("/support/");
  return (
    <>
      <section className="main-navbar">
        <div class="custom-container">
          <nav class="navbar navbarcustum navbar-expand-xl">
            <Link class="navbar-brand" to="/">
              <img src="\logo.svg" alt="logoimg" className="logoimg" />
            </Link>

            <button class="navbar-toggler" onClick={handleShowSidebar}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M3.3335 10H16.6668"
                    stroke="#0E1120"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.3335 5H16.6668"
                    stroke="#0E1120"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.3335 15H16.6668"
                    stroke="#0E1120"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </button>
            <div
              class="collapse navbar-collapse mobile-none"
              id="navbarSupportedContent"
            >
              <div className="navset">
                <ul className={`navbar-nav ${isHidden ? "navbar-hidden" : ""}`}>
                  <li class="nav-item">
                    <div
                      class="dropdown"
                      ref={dropdownRef}
                      onMouseEnter={() => handleMouseEnter(28)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span style={{
                          color: isOpen && '#FF0083',
                        }}>
                        Features
                        </span>
                        
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          className={`arrow-icon ${
                            isOpen ? "rotate-arrow" : ""
                          }`}
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.87102 5.62898L3.49979 5.25775L2.75732 6.00021L3.12856 6.37144L6.62856 9.87144L6.99979 10.2427L7.37102 9.87144L7.70888 9.53359L6.56592 8.32389L3.87102 5.62898ZM7.32905 8.42849L8.62238 8.62008L10.871 6.37144L11.2422 6.00021L10.4998 5.25775L10.1286 5.62898L7.32905 8.42849Z"
                            fill="#0E1120"
                          />
                        </svg>
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <Link to="/chatandpay" className={`dropdown-item ${currentRoute === "/chatandpay" ? "activelink" : ""}`}>
                            <img
                              className="img-fluid"
                              src="\assets\chaticondropdown.svg"
                              alt=""
                            />
                            Chats & Pay
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/buildgroup" ? "activelink" : ""}`} to="/buildgroup">
                            <img
                              className="img-fluid"
                              src="\assets\buildgroupicon.svg"
                              alt=""
                            />
                            Build Groups
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/createprofile" ? "activelink" : ""}`} to="/createprofile">
                            <img
                              className="img-fluid"
                              src="\assets\createprofileicon.svg"
                              alt=""
                            />
                            Create Profiles
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/browsesecurely" ? "activelink" : ""}`} to="/browsesecurely">
                            <img
                              className="img-fluid"
                              src="\assets\browssecurlyicon.svg"
                              alt=""
                            />
                            Browse Securely
                          </Link>
                        </li>
                        <li className="p-0">
                          <Link className={`dropdown-item lastitem ${currentRoute === "/feature" ? "activelink" : ""}`} to="/feature">
                          Explore All Features
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="nav-item">
                    <div
                      class="dropdown"
                      ref={dropdownRef1}
                      onMouseEnter={() => handleMouseEnter(158)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded={isOpen1}
                      >
                         <span style={{
                          color: isOpen1 && '#FF0083',
                        }}>
                        Company{" "}
                        </span>
                        <svg
                          className={`arrow-icon ${
                            isOpen1 ? "rotate-arrow" : ""
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.87102 5.62898L3.49979 5.25775L2.75732 6.00021L3.12856 6.37144L6.62856 9.87144L6.99979 10.2427L7.37102 9.87144L7.70888 9.53359L6.56592 8.32389L3.87102 5.62898ZM7.32905 8.42849L8.62238 8.62008L10.871 6.37144L11.2422 6.00021L10.4998 5.25775L10.1286 5.62898L7.32905 8.42849Z"
                            fill="#0E1120"
                          />
                        </svg>
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/aboutus" ? "activelink" : ""}`} to="/aboutus">
                            <img
                              className="img-fluid"
                              src="\assets\Aboutusnav.svg "
                              alt=""
                            />
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/whitepaper" ? "activelink" : ""}`} to="/whitepaper">
                            <img
                              className="img-fluid"
                              src="\assets\whitepapernav.svg"
                              alt=""
                            />
                            Whitepaper
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/brandguidelines" ? "activelink" : ""}`} to="/brandguidelines">
                            <img
                              className="img-fluid"
                              src="\assets\Brandguidline.svg"
                              alt=""
                            />
                            Brand Guidelines
                          </Link>
                        </li>
                        {/* <li><Link class="dropdown-item" to="/storage">
                          Storage</Link></li> */}
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/roadmap" ? "activelink" : ""}`} to="/roadmap">
                            <img
                              className="img-fluid"
                              src="\assets\Roadmapnav.svg"
                              alt=""
                            />
                            Roadmap
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="nav-item">
                    <div
                      class="dropdown"
                      onMouseEnter={() => handleMouseEnter(270)}
                      onMouseLeave={handleMouseLeave}
                      ref={dropdownRef2}
                    >
                      <button
                        class="btn btn-secondary dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                          <span style={{
                          color: isOpen2 && '#FF0083',
                        }}>
                        Help{" "}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          className={`arrow-icon ${
                            isOpen2 ? "rotate-arrow" : ""
                          }`}
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.87102 5.62898L3.49979 5.25775L2.75732 6.00021L3.12856 6.37144L6.62856 9.87144L6.99979 10.2427L7.37102 9.87144L7.70888 9.53359L6.56592 8.32389L3.87102 5.62898ZM7.32905 8.42849L8.62238 8.62008L10.871 6.37144L11.2422 6.00021L10.4998 5.25775L10.1286 5.62898L7.32905 8.42849Z"
                            fill="#0E1120"
                          />
                        </svg>
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <Link className={`dropdown-item ${currentRoute === "/contactus" ? "activelink" : ""}`} to="/contactus">
                            <img
                              className="img-fluid"
                              src="\assets\contactusnav.svg"
                              alt=""
                            />
                            Contact Us
                          </Link>
                        </li>
                        <li>
                        <Link className={`dropdown-item ${isActive ? "activelink" : ""}`} to="/support/welcome">
                            <img
                              className="img-fluid"
                              src="\assets\supportsvgheader.svg"
                              alt=""
                            />
                            Support
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="nav-item">
                    <Link
                      className="nav-link"
                      to="/blog"
                      onMouseEnter={() => handleMouseEnter(360)}
                      onMouseLeave={handleMouseLeave}
                    >
                      Blog
                    </Link>
                  </li>
                  <span
                    className="line"
                    style={{
                      display: isOpen || isOpen1 || isOpen2 ? 'none' : 'block',
                      left: linePosition,
                      scale: isHovered ? "1" : "0",
                      opacity: isHovered ? 1 : 0, // Show only on hover
                    }}
                  ></span>
                </ul>
              </div>
              <div class="d-flex tusfssfsuxfufsu">
                <div className="icons">
                  <HashLink
                    type="button"
                    class="btn btn-primary btn-common teritybtn"
                    to="/#getintouch "
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    Get Early Access
                  </HashLink>
                  {/* <HashLink className="btn-common teritybtn" to="/#getintouch ">Get Early Access</HashLink> */}
                </div>
              </div>
            </div>
          </nav>
        </div>
      </section>
      <div className="mobile-menu">
        <Offcanvas placement="bottom" show={showsidebar} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <a href="/" style={{textDecoration: 'none'}}>
              <img src="\logo.svg" alt="logoimg" className="logoimg" />
              </a>
              <button data-bs-toggle="modal"
            data-bs-target="#exampleModal" className="offcanvasheaderbtn teritybtn">
                Get Early Access
              </button>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="faqscustumdesigine">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <div className="btninner">Features</div>
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <ul class="dropdownnavs">
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/chatandpay" ? "activelink" : ""}`} to="/chatandpay">
                            <img
                              className="img-fluid"
                              src="\assets\chaticondropdown.svg"
                              alt=""
                            />
                            Chats & Pay
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/buildgroup" ? "activelink" : ""}`} to="/buildgroup">
                            <img
                              className="img-fluid"
                              src="\assets\buildgroupicon.svg"
                              alt=""
                            />
                            Build Groups
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/createprofile" ? "activelink" : ""}`} to="/createprofile">
                            <img
                              className="img-fluid"
                              src="\assets\createprofileicon.svg"
                              alt=""
                            />
                            Create Profiles
                          </Link>
                        </li>
                        <li>
                          <Link
                          className={`dropdownitemss ${currentRoute === "/browsesecurely" ? "activelink" : ""}`}
                            to="/browsesecurely"
                          >
                            <img
                              className="img-fluid"
                              src="\assets\browssecurlyicon.svg"
                              alt=""
                            />
                            Browse Securely
                          </Link>
                        </li>
                        <li>
                          <Link
                          className={`dropdownitemss ${currentRoute === "/feature" ? "activelink" : ""}`}
                            to="/feature"
                            style={{textAlign : 'center', justifyContent: 'center' , color : '#FF0083'}}
                          >
                        Explore All Features
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      <div className="btninner">Company</div>
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <ul class="dropdownnavs">
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/aboutus" ? "activelink" : ""}`} to="/aboutus">
                            <img
                              className="img-fluid"
                              src="\assets\Aboutusnav.svg"
                              alt=""
                            />
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/whitepaper" ? "activelink" : ""}`} to="/whitepaper">
                            <img
                              className="img-fluid"
                              src="\assets\whitepapernav.svg"
                              alt=""
                            />
                            Whitepaper
                          </Link>
                        </li>
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/brandguidelines" ? "activelink" : ""}`} to="/brandguidelines">
                            <img
                              className="img-fluid"
                              src="\assets\Brandguidline.svg"
                              alt=""
                            />
                            Brand Guidelines
                          </Link>
                        </li>

                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/roadmap" ? "activelink" : ""}`} to="/roadmap">
                            <img
                              className="img-fluid"
                              src="\assets\Roadmapnav.svg"
                              alt=""
                            />
                            Roadmap
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      <div className="btninner">Help</div>
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <ul class="dropdownnavs">
                        <li>
                          <Link className={`dropdownitemss ${currentRoute === "/contactus" ? "activelink" : ""}`} to="/contactus">
                            <img
                              className="imgfluid"
                              src="\assets\contactus.svg"
                              alt=""
                            />
                            Contact Us
                          </Link>
                        </li>
                        <li>
                        <Link className={`dropdownitemss ${currentRoute === "/support/welcome" ? "activelink" : ""}`} to="/support/welcome">
                            <img
                              className="imgfluid"
                              src="\assets\supportsvgheader.svg"
                              alt=""
                            />
                            Support
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <h5>
                  <Link to="/blog" className={` ${currentRoute === "/blog" ? "activelink" : ""}`}>Blog</Link>
                </h5>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
     
    </>
  );
};

export default Header;
